import axios from "axios";

const authAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL + "/api",
});

class VideoService {
  getVideos() {
    return authAxios.get(`/videos`, {
      withCredentials: true,
    });
  }
  addVideos(data){
    return authAxios.post(`/videos`, data , {
      withCredentials: true,
    });
  }
}
export default new VideoService();